import styled from "styled-components";

export const ModalRequestAuthorizationTable = styled.table`
    width: 99%;
    text-align: left;
    tr:first-of-type
    {
        border-bottom: 2px solid #e9eff2;
    }
    th
    {
        padding: 20px 10px 10px 10px;
        font-size: 14px;
        color: #2a4143;
        &:first-of-type
        {
            border-left: none;
        }
        &:last-of-type
        {
            border-left: none;
        }
    }
    td
    {
        padding: 8px;
        word-break: break-all;
        color: #95a0a1;
        /* border-left: 2px solid #e9eff2;
        border-right: 2px solid #e9eff2; */
        &:first-of-type
        {
            border-left: none;
        }
        &:last-of-type
        {
            border-left: none;
        }
    }
`;

export const SignatureComponentWrapper = styled.div`
    width: 99%;
    margin-top: 20px;
    h2{
        font-size: 20px;
    }
`;